<div class="card card-body d-flex flex-column ml-2 mr-2">
    <div class="d-flex ml-2 mr-2 mb-3">
        <div class="d-flex flex-row align-items-baseline">
            <i class="fa fa-info-circle red flex-shrink-0 mr-2"></i>
            <span class="subinformations" [innerHTML]="(hasGeneratedSecrets
              ? 'integration-apps-permission-secrets_new_explanation_text'
              : 'integration-apps-permission-secrets_existing_explanation_text') | i18next"></span>
        </div>
    </div>

    <div class="d-flex flex-column ml-2 mr-2 mt-1 mb-1">
        @for (item of permissionsWithSecret; track item.identifier) {
            <div class="d-flex flex-row align-items-center mt-2">
                @if (item.generatedSecret) {
                    <div class="d-flex flex-row align-items-center justify-content-center" style="border: 1px solid #d9d9d9; 
                        border-radius: 4px; padding: 0.5rem; background-color: lightgoldenrodyellow; width: 100%;">
                        <h4 class="m-0">Secret: {{ item.generatedSecret }}</h4>
                        <i class="fa-regular fa-copy fa-xl hover-effect ml-3" style="color: #a3a3a3" [cdkCopyToClipboard]="item.generatedSecret"
                            (cdkCopyToClipboardCopied)="showCopied()"></i>
                    </div>
                }
            </div>
            @if (copied && item.generatedSecret) {
                <div class="d-flex flex-row justify-content-center mt-1">
                    <span class="text-muted subinformations ml-3">{{ 'integration-apps-permission-secrets_copied_hint' | i18next }}</span>
                </div>
            }
            @if (item.generatedSecret && hasMoreThanOnePermissionSet) {
                <span class="mt-4" [innerHTML]="'integration-apps-permission-secrets_identifier_value' | i18next: { identifier: item.identifier }"></span>
            }
            <div class="d-flex flex-column mt-2 mb-2">
                @for(scope of item.scopes; track $index) {
                    <div class="d-flex flex-row align-items-center mt-3">
                        <div class="d-flex align-items-center justify-content-center mr-1" style="width: 30px;">
                            @if (scope.includes('read')) {
                                <i class="fa fa-book"></i>
                            } @else if (scope.includes('write')) {
                                <i class="fa fa-pen"></i>
                            } @else {
                                <i class="fa fa-check"></i>
                            }
                        </div>
                        <span>{{ getTranslationKeyFromScopeValue(scope) | i18next }}</span>
                    </div>
                }
            </div>
            <hr>
        }
    </div>
    <div class="ml-2 mr-2 mt-4">
        <app-pascom-checkbox [text]="(hasGeneratedSecrets 
          ? 'integration-apps-permission-secrets_new_confirm_text'
          : 'integration-apps-permission-secrets_existing_confirm_text') | i18next" (acceptChanged)="accept($event)"></app-pascom-checkbox>
    </div>
    <div class="align-self-end mt-3">
        <button class="btn btn-outline-white mr-2" (click)="onCancel()">{{ 'app_cancel' | i18next }}</button>
        <button class="btn btn-outline-primary" type="submit" (click)="hashAndInstall()" [disabled]="!accepted">
            {{ (isUpgrade ? 'integration_apps_upgrade_hint' : 'integration_apps_install_hint') | i18next }}</button>
    </div>
</div>